import { AlertProps } from '@mui/material'
import React, { useCallback } from 'react'

import { styled, Z_INDEX } from '../../theme'
import { BaseAlert } from '../BaseAlert'
import { Box } from '../Box'
import { Typography } from '../Typography'

const StyledBox = styled(Box)`
  width: 310px;
  position: fixed;
  top: 20px;
  left: 0;
  right: 0;
  z-index: ${Z_INDEX.notification};
  justify-content: center;
  display: 'flex';
  margin: auto;
`

type Props = Pick<AlertProps, 'severity' | 'onClose'> & { alertMessage: string; isShowing: boolean }

export const Alert = (props: Props) => {
  const { alertMessage, isShowing, onClose, severity } = props

  const close = useCallback((event: React.SyntheticEvent<Element, Event>) => {
    onClose && onClose(event)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <StyledBox hidden={!isShowing}>
      <BaseAlert severity={severity} onClose={close}>
        <Typography variant="body2">{alertMessage}</Typography>
      </BaseAlert>
    </StyledBox>
  )
}
